import React from 'react';
import { useTranslationContext } from '../../context/TranslationContext';
export var SearchInput = function (props) {
    var channelSearchParams = props.channelSearchParams, inputRef = props.inputRef, onSearch = props.onSearch, query = props.query, searchFunction = props.searchFunction;
    var t = useTranslationContext('SearchInput').t;
    return (React.createElement("input", { className: 'str-chat__channel-search-input', onChange: function (event) {
            return searchFunction ? searchFunction(channelSearchParams, event) : onSearch(event);
        }, placeholder: t('Search'), ref: inputRef, type: 'text', value: query }));
};
